import angular from 'angular';
import _ from 'lodash';
import {fields} from './fields.js';
import {povijestBolesti} from './povijestBolesti.js';
import {ginekoloskaPosjeta} from './ginekoloskaPosjeta.js';
import swal from 'sweetalert';


function SaveToDisk(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        debugger;
        var save = window.document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        // save.download = fileName || 'unknown';

        var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });
        save.dispatchEvent(evt);

        (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }

    // for IE < 11
    else if ( !! window.ActiveXObject && window.document.execCommand) {
        var _window = window.open(fileURL, '_blank');
        // _window.document.close();
        // _window.document.execCommand('SaveAs', true, fileName || fileURL);
        // _window.close();
    }
}

class FormController {
    constructor($scope, Model, PacijentFactory, DjelatnostPoliklinike) {
        this.Model = Model;
        this.PacijentFactory = PacijentFactory;
        this.Djelatnost = DjelatnostPoliklinike;
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
        this.djelatnost = [fields.djelatnost];
        this.vrstaPosjete = [fields.vrstaPosjete];
        this.hideWizard = false;
        this.ginekoloskaPosjeta = false;
        if (angular.isDefined(this.clone.djelatnost)) {
            // vjerojatno smo u edit modu ako je već u ovoj fazi
            // poznata djelatnost.
            this.Djelatnost.find(this.clone.djelatnost).then((djelatnost) => {
                this.fields = this.getFields(djelatnost);
            });

            this.getPreglede(this.clone.pacijent, this.clone.djelatnost, this.clone.datum, this.clone.sifra);
            this.hideWizard = true;
        }
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal({
                    title: "",
                    text: "Podaci su uspiješno pohranjeni!",
                    type: "success",
                    showCancelButton: true,
                    confirmButtonColor: "#23c6c8",
                    confirmButtonText: "Ispiši",
                    cancelButtonText: 'Zatvori',
                    closeOnConfirm: true
                },
                function(){
                    SaveToDisk('/api/ordinacija/reports/pregled/' + data.id +'/');
                    return false;
                });
            // swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(djelatnost){

        // if (djelatnost.naziv === "Ginekologija i opstetricija") {
        //     this.ginekoloskaPosjeta = true;
        //     return ginekoloskaPosjeta;
        // }
        this.ginekoloskaPosjeta = false;
        return povijestBolesti;
    }

    getPreglede(pacijent, djelatnost, datum, sifra){
        this.Model.findAll({
            pacijent: pacijent,
            djelatnost: djelatnost,
            datum__lte: datum,
            sifra__lt: sifra})
        .then((data) => {
            this.clone.pregledi = data;
        });
    }

    finishedWizard(model){
        this.Djelatnost.find(model.djelatnost).then((djelatnost) => {
            this.fields = this.getFields(djelatnost);
        });
        // this.clone = angular.copy(this.model);
        // this.clone.djelatnost = newValue;

        if (angular.isDefined(model.pacijent)){
            this.getPreglede(model.pacijent, model.djelatnost, model.datum);
        };

        this.hideWizard = true;
    }
}

FormController.$inject = ['$scope', 'Pregled', 'Pacijent', 'DjelatnostPoliklinike'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/pregled/form/form.controller.js